import React from 'react';
import PopPop from 'react-poppop';

const contentStyle = {
	borderRadius: 0,
	maxWidth: '450px',
	padding: '1.8rem 2rem',
};

const AlertModal = ({ children, onClose }) => {
	return (
		<PopPop
			open={!!children}
			position="centerCenter"
			closeBtn={true}
			closeOnEsc={true}
			closeOnOverlay={true}
			onClose={onClose}
			contentStyle={contentStyle}
		>
			{children}
		</PopPop>
	);
};

export default AlertModal;
